export const TARGET_APPLIED_ON_OPTIONS = [
  { value: "INDIVIDUAL_MODEL", label: "Per model (each product's own count)" },
  { value: "TOTAL_UNITS", label: "Total units across group" },
  { value: "TOTAL_DP_VALUE", label: "Total DP value across group" },
  { value: "TOTAL_UNITS_TARGET_FROM_RETAILER", label: "% of retailer's unit target" },
  { value: "TOTAL_DP_VALUE_TARGET_FROM_RETAILER", label: "% of retailer's DP-value target" },
];

export const TARGET_FROM_RETAILER_TYPES = [
  "TOTAL_UNITS_TARGET_FROM_RETAILER",
  "TOTAL_DP_VALUE_TARGET_FROM_RETAILER",
];

export const SELL_TYPE_OPTIONS = [
  { value: "SELL_IN", label: "Purchase" },
  { value: "SELL_OUT", label: "Sale" },
  { value: "SELL_IN_AND_SELL_OUT", label: "Purchase + Sale" },
  { value: "ACTIVATION", label: "Activation" },
];

export const PAYOUT_TYPE_OPTIONS = [
  { value: "PER_UNIT_AMOUNT", label: "₹ per unit" },
  { value: "PERCENTAGE_OF_DP", label: "% of DP per unit" },
  { value: "PER_UNIT_POINTS", label: "Points per unit" },
  { value: "GIFT_REWARD_TRIP", label: "Gift / Reward / Trip" },
  { value: "FIXED_SLAB_AMOUNT", label: "Fixed amount for the slab (lump-sum)" },
  { value: "PRICE_PROTECTION", label: "Price protection" },
];

export const SCHEME_STATUS_OPTIONS = [
  { value: "DRAFT", label: "Draft" },
  { value: "IN_REVIEW", label: "In Review" },
  { value: "ACTIVE", label: "Active" },
  { value: "ARCHIVED", label: "Archived" },
];

export const EXCLUSION_REASON_LABELS = {
  COLOR_UNKNOWN: "Color unknown",
  NO_SLAB_MATCHED: "No slab matched",
  PRICE_NOT_FOUND: "Price not found",
  OUTSIDE_PERIOD: "Outside period",
};

export const getInitialSlab = () => ({
  rangeFrom: "",
  rangeTo: "",
  amount: "",
  gift: "",
  remark: "",
  periodFrom: "",
  periodTo: "",
  isDefaultSlab: false,
});

export const getInitialConfig = () => ({
  name: "",
  targetGroupId: "",
  targetAppliedOn: "INDIVIDUAL_MODEL",
  achievementBasis: "SELL_OUT",
  payoutBasis: "SELL_OUT",
  payoutType: "PER_UNIT_AMOUNT",
  periodFrom: "",
  periodTo: "",
  helpText: "",
  protection: { claimWindowDays: "", brandStatedClaimValuePerUnit: "" },
  slabs: [getInitialSlab()],
});

export const getInitialTargetGroup = () => ({
  name: "",
  templateId: "",
  productIds: [],
  products: [], // UI-only, for the AutoComplete display value
  attributeFilters: {
    colorIds: "",       // comma-separated ids in the UI, split on save
    variantFilters: "", // JSON string in the UI (e.g. {"RAM":["8GB","12GB"]}), parsed on save
    dpBandGte: "",
    dpBandLte: "",
  },
});

export const getInitialSchemePayload = (periodFrom, periodTo) => ({
  id: null,
  name: "",
  description: "",
  imageUrl: "",
  termsAndConditions: "",
  brandId: null,
  brandName: "",
  periodFrom,
  periodTo,
  groupIds: [],
  groups: [],
  retailerTypeId: "",
  retailerTypeName: "",
  targetGroups: [getInitialTargetGroup()],
  configs: [getInitialConfig()],
  status: "DRAFT",
  publishVersion: null,
});

export const getInitialTemplatePayload = (brandId) => ({
  id: null,
  brandId,
  targetGroup: getInitialTargetGroup(),
});
